export const mapDeviceType = (deviceType) => {
    const typeMapping = {
        HE_BAT: 'HomeGrid Battery',
        // Add more mappings here as needed
    };
    return typeMapping[deviceType] || deviceType; // Return the mapped value or the original if not found
};
